import api from "../axiosInstance";

export const getStatisticsDataAPI = async () => {
  try {
    const response = await api.get(`admin/dashboard`);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const getPartnershipData = async (pageParam, perPageITem) => {
  try {
    const response = await api.get(
      `partnerShip/adminbyStatus?page=${pageParam}&limit=${perPageITem}`
    );
    return response.data;
  } catch (err) {
    console.log("getPartnershipData API --", err);
  }
};

export const updatePartnershipStatus = async (payload) => {
  try {
    const response = await api.put(
      `partnerShip/adminbyStatus?partnerShipId=${payload.id}&userId=${payload.userId}&status=${payload.status}`
    );
    return response.data;
  } catch (err) {
    console.log("updatePartnershipStatus API --", err);
  }
};

export const getUserPartnershipDataFilterAPI = async (
  pageParam,
  status,
  perPageITem
) => {
  try {
    const response = await api.get(
      `partnerShip/adminbyStatus?page=${pageParam}&limit=${perPageITem}&status=${status}`
    );
    return response.data;
  } catch (err) {
    console.log("getPartnershipData API --", err);
    return;
  }
};
